/// <amd-module name="typeahead/client/ActivitiesSearchResultsPageHandler" />

import {ClientHandlerRegistry, IClientHandler} from "typeahead/client/ClientHandlerRegistry";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";

export class ActivitiesSearchResultsPageHandler implements IClientHandler {
    private static readonly rfrrIdPrefix: string = "LX.SR|UpdateSearch";
    private static readonly APPLICABLE_CLIENT_ID = "LX.Search";

    public isApplicable(clientId: string): boolean {
        return ActivitiesSearchResultsPageHandler.APPLICABLE_CLIENT_ID === clientId;
    }

    public subscribeFormSubmitEvent(): void {
        $("body").on("click", "a#toggleSearch", () => {
            $("button#srpSearch").click(() => {
                ClientHandlerRegistry.publishSubmitClickedMessage(ActivitiesSearchResultsPageHandler.rfrrIdPrefix);
                // The form is presumed to be valid regardless of the fact, because the validation is done on the server
                // side.
                ClientHandlerRegistry.publishFormSubmittedMessage(true);
            });
        });
    }

    public subscribeFormLoadedEvent(): void {
        // TODO
        /* Publish  a 'FormLoadedMessage' when any feature requires listening to form getting visible
        (when clicking Change Search) */
    }

    public getTab(): string {
        return undefined;
    }

    public getGeolocationViewController(): GeolocationViewController {
        return undefined;
    }
}
